import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type UploadBase from "@/pages/Upload.Base.vue";

export default defineMosaicComponent<typeof UploadBase>("pages/Upload");
